var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "file_exchange wrap_panel" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "exchange_body" }, [
      _c("div", {}, [
        _c(
          "ul",
          { staticClass: "imc_box row" },
          _vm._l(_vm.icons, function (icon) {
            return _c(
              "li",
              {
                staticClass: "mt-3 mb-3 col-md-4 col-xs-6 col-lg-3 col-xl-2",
                on: {
                  click: function ($event) {
                    return _vm.set_active(icon)
                  },
                },
              },
              [
                _c(
                  "a",
                  {
                    staticClass:
                      "user_list bg-primary-500 color-primary-500 active",
                    attrs: { href: "#" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "menu_item menu_item rounded hover-bg shadow-hover text-center shadow-sm border",
                      },
                      [
                        _c("div", { staticClass: "icon" }, [
                          _c("i", { staticClass: "fal", class: icon.icon }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "content" }, [
                          _c("p", { staticClass: "name" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t\t" +
                                _vm._s(icon.title) +
                                "\n\t\t\t\t\t\t\t\t"
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "some_info mt-5 mb-5" }, [_c("f_info")], 1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "view_type" },
        [
          _vm.cur_view == "files" ? _c("f_files") : _vm._e(),
          _vm._v(" "),
          _vm.cur_view == "users" ? _c("f_users") : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex flex-start w-100" }, [
      _c("div", { staticClass: "mr-2 hidden-md-down" }, [
        _c("span", { staticClass: "icon-stack icon-stack-lg" }, [
          _c("i", {
            staticClass:
              "base base-6 icon-stack-3x opacity-100 color-primary-500",
          }),
          _vm._v(" "),
          _c("i", {
            staticClass: "ni ni-notebook icon-stack-1x opacity-100 color-white",
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-fill" }, [
        _c("div", { staticClass: "flex-fill" }, [
          _c("span", { staticClass: "h5" }, [_vm._v("File exchange IMC")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }